MyBrowser =
  ua: global.navigator.userAgent.toLowerCase()
  ver: undefined

  isIe: ->
    @ua.indexOf('msie') != -1 or @ua.indexOf('trident') != -1

  isIe6: ->
    @ua.indexOf('msie 6.') != -1

  isIe7: ->
    @ua.indexOf('msie 7.') != -1

  isIe8: ->
    @ua.indexOf('msie 8.') != -1

  isIe9: ->
    @ua.indexOf('msie 9.') != -1

  isIe10: ->
    @ua.indexOf('msie 10.') != -1

  isOldIe: ->
    @isIe8() || @isIe7() || @isIe6()

  isChrome: ->
    @ua.indexOf('chrome') != -1

  isSafari: ->
    @ua.indexOf('safari') != -1 && !@isChrome()

  isFirefox: ->
    @ua.indexOf('firefox') != -1

  isOpera: ->
    @ua.indexOf('opera') != -1

  isIphone: ->
    @ua.indexOf('iphone') != -1 || @ua.indexOf('ipod') != -1

  isAndroidSp: ->
    @ua.indexOf('android') != -1 && @ua.indexOf('mobile') != -1

  isSp: ->
    @isAndroidSp() || @isIphone()

  isIpad: ->
    @ua.indexOf('ipad') != -1

  isAndroidTab: ->
    @ua.indexOf('android') != -1 && !@isAndroidSp()

  isTablet: ->
    @isIpad() || @isAndroidTab()

  isMobile: ->
    @isSp() || @isTablet()

  isIos: ->
    @isIphone() || @isIpad()

  isAndroid: ->
    @ua.indexOf('android') != -1



module.exports = MyBrowser



// WEBPACK FOOTER //
// ./src/scripts/modules/MyBrowser.coffee